// No browser suggestions (autofill history) on any input / textarea in the app.
// Applied globally instead of per field: on focus (before the browser shows its list) and to fields added later.
// A field that needs suggestions can opt out with data-autocomplete="on".
const FIELDS = "input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]), textarea";

function apply(el) {
  if (!el || !el.matches || !el.matches(FIELDS) || el.dataset.autocomplete === "on") return;
  if (el.getAttribute("autocomplete") !== "off") el.setAttribute("autocomplete", "off");
}

export function disableBrowserSuggestions() {
  document.addEventListener("focusin", (e) => apply(e.target), true);
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        apply(node);
        node.querySelectorAll && node.querySelectorAll(FIELDS).forEach(apply);
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.querySelectorAll(FIELDS).forEach(apply);
}
